var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { createContext } from 'react';
import { addMissingConfig } from '../boot/addMissingConfig';
export const ShopConfigContext = createContext(undefined);
export function ConfigProvider(_a) {
    var { config: userConfig, children } = _a, rest = __rest(_a, ["config", "children"]);
    const config = addMissingConfig(userConfig);
    return (React.createElement(ShopConfigContext.Provider, Object.assign({ value: config }, rest), children));
}
//# sourceMappingURL=ConfigProvider.js.map